import type { Locale } from "@/lib/i18n";
import { pl, type CUserAccountsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cUserAccountsTranslations: Record<Locale, CUserAccountsTranslations> = {
  pl,
  en,
  de,
};

export type { CUserAccountsTranslations };
